const locale = require('./inviteChat.i18n.json');
    /*@ngInject*/
    const InviteChatModalController = function ($rootScope, $scope, $stateParams, coreMediator, coreConstant, collaborationMediator) {
        $scope.i18n = locale;

        $scope.viewModel = {
            title: $scope.i18n.title,
            cancelButton: $scope.i18n.cancelButton,
            okButton: $scope.i18n.inviteButton,
            promptValue: $scope.i18n.promptValue,
            peopleLabel: $scope.i18n.people,
            defaultMessage: $scope.i18n.defaultMessage,
            successMessage: $scope.i18n.successMessage,
            successUserMessage: $scope.i18n.successUserMessage,
            warningText: $scope.i18n.warningText,
            userList: [],
            buttonClass: 'btn-success',
            itemName: 'chat',
            isInvitationSent: false,
            selectedUserIds: [],
            selectedUsers: []
        };

        $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
            if (itemName === $scope.viewModel.itemName) {
                $scope.viewModel.selectedUsers = [];
                _.each($scope.viewModel.userList, function (user) {
                    if (user.selected) {
                        $scope.viewModel.selectedUsers.push(user);
                    }
                });
            }
        });

        $scope.onConfirm = function () {
            let selectedUserNames = '',
                count = 0;

            _.each($scope.viewModel.selectedUsers, function (user) {
                count++;
                $scope.viewModel.selectedUserIds.push(user.id);
                if (selectedUserNames !== '') {
                    if (count === $scope.viewModel.selectedUsers.length) {
                        selectedUserNames += ' and ';
                    } else {
                        selectedUserNames += ', ';
                    }
                }
                selectedUserNames += user.name;
            });

            collaborationMediator.sendChatInvitation($stateParams.submissionId, $scope.viewModel.selectedUserIds, $scope.viewModel.defaultMessage).then(function () {
                $scope.$dismiss();
                $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLEAR, $scope.viewModel.itemName);
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, $scope.i18n.notificationMessage);

            });
        };

        $scope.onCancel = function () {
            if ($scope.viewModel.selectedUsers.length > 0) {
                $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLEAR, $scope.viewModel.itemName);
            }
            $scope.$dismiss();
        };

        $scope.canEnableConfirmButton = function () {
            return $scope.viewModel.selectedUsers.length > 0;
        };

        $scope.init = function () {
            coreMediator.loadUsersList($stateParams.submissionId).then(function (users) {
                $scope.viewModel.userList = users;
            });
        };

        $scope.init();

        $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
            $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
        });

        $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
    };

    angular.module('gw-um-submission')
        .controller('inviteChatModalController', InviteChatModalController);
